import React from 'react';
import ReactDOM from 'react-dom/client'; // ✅ usa react-dom/client
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// ✅ Registrazione del service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then(registration => {
        // opzionale: log o uso della registration
      })
      .catch(err => {
        console.error('Errore nella registrazione del Service Worker:', err);
      });
  });
}
